// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  transition: transform 0.15s linear;
  width: 100%;
  height: 100%;
  margin: 0;
  --border-radius: 0;
  --box-shadow: none!important;
}
ion-button.button-keypad-pressed {
  transform: scale(0.8);
}
ion-button ion-icon {
  width: 100%;
  height: 100%;
  display: block;
}

ion-label {
  width: 100%;
  height: 100%;
  font-size: 2em;
  line-height: 2em;
  letter-spacing: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bigger-font {
  font-size: xx-large;
}

.container-keypad {
  width: 100%;
  height: 100%;
}

.container-numeric-keypad-button {
  width: 100%;
  height: 90%;
  padding: 0 !important;
  display: flex;
  flex-wrap: wrap;
}

.container-single-button {
  width: 33.3333333333%;
  height: 25%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-label-code-viewer {
  text-align: center;
  height: 10%;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/numeric-keypad/numeric-keypad.component.scss","webpack://./src/components/general%20components/numeric-keypad/numeric-keypad.component.scss"],"names":[],"mappings":"AAEA;EACI,kCAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,4BAAA;ACDJ;ADGI;EACI,qBAAA;ACDR;ADII;EACI,WAAA;EACA,YAAA;EACA,cAAA;ACFR;;ADMA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACHJ;;ADMA;EACI,mBAAA;ACHJ;;ADMA;EACI,WAAA;EACA,YAAA;ACHJ;;ADOA;EACI,WAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;ACJJ;;ADQA;EACI,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACLJ;;ADQA;EACI,kBAAA;EACA,WAAA;ACLJ","sourcesContent":["\n\nion-button {\n    transition: transform 0.15s linear;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    --border-radius: 0;\n    --box-shadow: none!important;\n\n    &.button-keypad-pressed{\n        transform: scale(0.8);\n    }\n\n    ion-icon {\n        width: 100%;\n        height: 100%;\n        display: block;\n    }\n}\n\nion-label{\n    width: 100%;\n    height: 100%;\n    font-size: 2em;\n    line-height: 2em;\n    letter-spacing: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.bigger-font{\n    font-size: xx-large;\n}\n\n.container-keypad{\n    width: 100%;\n    height: 100%;\n}\n\n\n.container-numeric-keypad-button {\n    width: 100%;\n    height: 90%;\n    padding: 0!important;\n    display: flex;\n    flex-wrap: wrap;\n\n}\n\n.container-single-button{\n    width: calc(100% / 3);\n    height: calc(100% / 4);\n    box-sizing: border-box;\n    padding: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.container-label-code-viewer {\n    text-align: center;\n    height: 10%;\n}\n\n","ion-button {\n  transition: transform 0.15s linear;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  --border-radius: 0;\n  --box-shadow: none!important;\n}\nion-button.button-keypad-pressed {\n  transform: scale(0.8);\n}\nion-button ion-icon {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\nion-label {\n  width: 100%;\n  height: 100%;\n  font-size: 2em;\n  line-height: 2em;\n  letter-spacing: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bigger-font {\n  font-size: xx-large;\n}\n\n.container-keypad {\n  width: 100%;\n  height: 100%;\n}\n\n.container-numeric-keypad-button {\n  width: 100%;\n  height: 90%;\n  padding: 0 !important;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.container-single-button {\n  width: 33.3333333333%;\n  height: 25%;\n  box-sizing: border-box;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container-label-code-viewer {\n  text-align: center;\n  height: 10%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
